import React from 'react';
import ReactGA from 'react-ga';

function ThankYou(props) {

  const subscribe = () => {
    props.subscribe('book');
  };

  ReactGA.set({ page: window.location.pathname }); // Update the user's current page
  ReactGA.pageview(window.location.pathname); // Record a pageview for the given page
 
  return (
    <div className="thank-you m-auto p-5">
      <div className="row mobile-m-auto mobile-text-center">


        <div className="col-sm-6 col-md-5 d-none d-sm-block">
                  <img src="./img/ebook.png" alt="eBook" className="col-12 pt-4" />
        </div>

        <div className="col-12 col-sm-6 col-md-7">
          <div className="row">
            <h1 className="col-12 blue-font">Thank You!</h1>
            <a className="col-8 float-none mobile-m-auto mobile-text-center text-decoration-none" href={props.downloadUrl}>
                <h4 className="red-font mt-2">
                To download the eBook please click here
            </h4>
            </a>
            <div className="col-12 mt-3 mb-3 mobile-text-center">
                <a className="btn btnApetito pt-2" href={props.downloadUrl}>Download Now</a>
            </div>

                      <img src="./img/ebook.png" className="d-block d-sm-none col-6 mobile-m-auto pt-4" alt="ebook"/>

            {props.subscribedToBookList ?
                <h4 className="col-12 mt-4 mobile-text-center">Thanks for signing up</h4>
                          :
                <div className="col-12">
                    <h4 className="col-12 mt-4 mb-4 mobile-text-center blue-font">
                        If you prefer, you can receive the eBook in snackable portions!<br /><br />

                        Each week you will receive one nutrition myth (debunked) directly to your email:
                    </h4>

                    <div className="col-3 p-0 m-0 float-left">
                        <span className={props.formErrors.email !== '' ? 'red-font' : ''}>
                            Email:
                        </span>              
                    </div>
                    <input className="col-8" type="text" value={props.user.email} onChange={(e) => props.updateUser('email', e.target.value)} />

                    <div className="col-12 mt-3 no-spam">
                        We will not send you any spam.  You can unsubscribe at any time.
                    </div>
                    <div className="col-12 mt-3 mobile-text-center book-list-button-container">
                        <button className="book-list-button btn btnApetito pt-2" onClick={subscribe} disabled={!props.emailValid}>
                            Sign up to receive the weekly myth
                        </button>
                    </div>
                </div>
                }
            
          </div>
        </div>
      </div>
    </div>
  )
}

export default ThankYou;
